;(function($){
    var $detailBtn = $('#detailBtn');
    var $content = $('#detailBtnWrap').next();

    var $moreBtn = $('#moreBottomHide');
    var $contentNum = $('#premiumList').find('>li').length;
    var $moreContent = $('#premiumList').find('>li').slice(5).addClass('off');
    if($contentNum < 6) {
        $moreBtn.hide();
    }

    $detailBtn.on('click',function(e) {
        $content.toggleClass('off');
    });

    $moreBtn.on('click',function(e) {
        $('#premiumList').find('>li').removeClass('off');
        $moreBtn.hide();
    });
})(jQuery);